import { memo } from 'react';

const HeaderFlowers = memo(() => {
  // Criar 12 flores decorativas espalhadas no header
  const flowers = [
    { left: '5%', size: 24, rotation: 15, color: 'hsl(330 60% 85%)' },
    { left: '12%', size: 20, rotation: -20, color: 'hsl(340 65% 88%)' },
    { left: '22%', size: 28, rotation: 45, color: 'hsl(310 55% 90%)' },
    { left: '35%', size: 22, rotation: -10, color: 'hsl(350 60% 86%)' },
    { left: '45%', size: 26, rotation: 30, color: 'hsl(320 58% 87%)' },
    { left: '55%', size: 24, rotation: -25, color: 'hsl(340 62% 89%)' },
    { left: '65%', size: 20, rotation: 50, color: 'hsl(330 56% 88%)' },
    { left: '72%', size: 28, rotation: -15, color: 'hsl(310 60% 85%)' },
    { left: '80%', size: 22, rotation: 20, color: 'hsl(350 58% 90%)' },
    { left: '88%', size: 26, rotation: -30, color: 'hsl(320 64% 86%)' },
    { left: '95%', size: 24, rotation: 40, color: 'hsl(340 60% 88%)' },
    { left: '60%', size: 18, rotation: -40, color: 'hsl(330 62% 92%)' },
  ];

  return (
    <div className="absolute inset-x-0 top-0 h-16 pointer-events-none overflow-hidden">
      {flowers.map((flower, i) => (
        <div
          key={i}
          className="absolute top-2 flower"
          style={{
            left: flower.left,
            width: `${flower.size}px`,
            height: `${flower.size}px`,
            transform: `rotate(${flower.rotation}deg)`,
            animation: `float-flower ${3 + (i % 3)}s ease-in-out infinite`,
            animationDelay: `${i * 0.3}s`,
          }}
        >
          {/* Pétalas da flor */}
          <div className="relative w-full h-full">
            {[0, 72, 144, 216, 288].map((angle) => (
              <div
                key={angle}
                className="absolute top-1/2 left-1/2 w-2/5 h-3/5 rounded-full"
                style={{
                  background: `linear-gradient(135deg, ${flower.color}, hsl(0 0% 100% / 0.7))`,
                  transform: `translate(-50%, -50%) rotate(${angle}deg) translateY(-40%)`,
                  transformOrigin: 'center',
                  boxShadow: `0 1px 3px hsl(330 50% 70% / 0.3)`,
                }}
              />
            ))}
            {/* Centro da flor */}
            <div
              className="absolute top-1/2 left-1/2 w-2/5 h-2/5 rounded-full"
              style={{
                background: 'linear-gradient(135deg, hsl(45 90% 70%), hsl(50 85% 75%))',
                transform: 'translate(-50%, -50%)',
                boxShadow: '0 1px 2px hsl(45 70% 50% / 0.4)',
              }}
            />
          </div>
        </div>
      ))}
      <style>{`
        @keyframes float-flower {
          0%, 100% {
            transform: translateY(0) rotate(var(--rotation));
          }
          50% {
            transform: translateY(-8px) rotate(calc(var(--rotation) + 5deg));
          }
        }
        
        .flower {
          --rotation: 0deg;
        }
      `}</style>
    </div>
  );
});

HeaderFlowers.displayName = 'HeaderFlowers';

export default HeaderFlowers;
